<template>
  <div>
    <div style="display: flex">
      <div
        class="gzh-window-box"
        :style="{ height: right_content_height + 'px' }"
      >
        <img
          style="width: 100%; user-select: none"
          src="../../../assets/gzh_top_nav.jpg"
          alt=""
        />
        <div style="display: flex; user-select: none">
          <template v-for="(item, index) in contentData">
            <div style="position: relative; flex: 1">
              <div
                :class="{ 'temp-event-all': page_type == 'config-template' }"
                @click="selectContent(item, index)"
                class="add-button"
                :style="{
                  border:
                    index == content_index_select && item.second_index == -1
                      ? '2px solid #2dce89'
                      : '1px solid #cbcbcb',
                }"
              >
                {{ item.name || "菜单名称" }}
              </div>
              <div class="gzh-nav-box">
                <template v-for="(ite_z, inde_z) in item.sub_button">
                  <div
                    class="gzh-nav"
                    :class="{
                      'temp-event-all': page_type == 'config-template',
                    }"
                    @click="secondContent(item, index, ite_z, inde_z)"
                    :style="{
                      border:
                        inde_z == item.second_index
                          ? '2px solid #2dce89'
                          : '1px solid #cbcbcb',
                    }"
                  >
                    {{ ite_z.name || "子菜单名称" }}
                  </div>
                </template>
                <div
                  v-if="item.sub_button.length < 5"
                  @click="addButtonB(index)"
                  class="gzh-nav"
                >
                  +
                </div>
                <div class="triangle-icon"></div>
              </div>
            </div>
          </template>
          <div
            v-if="contentData.length < 3"
            @click="addButtonA"
            class="add-button"
          >
            +添加
          </div>
        </div>
      </div>
      <div style="width: 620px; margin-left: 30px; border: 1px dotted #d1d1d1">
        <!-- 点击左侧添加菜单开始 -->
        <div
          v-if="contentData.length == 0"
          style="
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: default;
            font-size: 18px;
            font-weight: 600;
          "
        >
          点击左侧添加菜单开始
        </div>

        <!-- 菜单名称-没有子菜单的情况下 -->
        <div
          v-else-if="
            contentData.length > 0 &&
            contentData[content_index_select].show_type == 1
          "
          style="width: 100%; height: 100%; padding: 30px 15px"
        >
          <div class="form-cell-box">
            <div class="class-title">菜单名称</div>
            <a-input
              v-model="contentData[content_index_select].name"
              @blur="campaignNameBlur($event, 1)"
              ref="focusA"
              placeholder="请输入菜单名称"
              style="width: 300px"
            />
          </div>

          <div style="padding-left: 35px; margin-bottom: 20px; color: #999">
            说明：当前菜单有子菜单，只能设置名称
          </div>

          <a-button @click="delContentA" style="margin-left: 35px" type="danger"
            >删除当前菜单项</a-button
          >
        </div>

        <!-- 一级菜单 -->
        <div
          v-else-if="
            contentData.length > 0 &&
            contentData[content_index_select].show_type == 2
          "
          style="width: 100%; height: 100%; padding: 30px 30px 30px 15px"
        >
          <div class="form-cell-box">
            <div class="class-title">菜单名称</div>
            <a-input
              v-model="contentData[content_index_select].name"
              @blur="campaignNameBlur($event, 1)"
              ref="focusA"
              placeholder="菜单名称"
              style="width: 300px"
            />
          </div>

          <div class="form-cell-box">
            <div class="class-title">菜单内容</div>
            <div v-if="set_type === 'h5'">
              <a-radio-group
                @change="onChangeB"
                name="radioGroup"
                :value="contentData[content_index_select].type"
              >
                <a-radio value="click">发送消息</a-radio>
                <a-radio value="view">跳转网页</a-radio>
                <!-- <a-radio value="miniprogram">跳转小程序</a-radio> -->
              </a-radio-group>
            </div>
            <div v-if="set_type === 'mini'">
              <a-radio-group
                @change="onChangeB"
                name="radioGroup"
                :value="contentData[content_index_select].type"
              >
                <a-radio value="click">发送消息</a-radio>
                <!-- <a-radio value="view">跳转网页</a-radio> -->
                <a-radio value="miniprogram">跳转小程序</a-radio>
              </a-radio-group>
            </div>
          </div>

          <div
            style="
              margin-left: 15px;
              margin-bottom: 30px;
              border: 1px solid #e1e1e1;
              padding: 25px;
            "
          >
            <template v-if="contentData[content_index_select].type == 'click'">
              <div style="margin-bottom: 20px">
                <a-radio-group
                  @change="onChangeC"
                  name="radioGroup"
                  :value="contentData[content_index_select].config.type"
                >
                  <a-radio :value="1">文本消息</a-radio>
                  <a-radio :value="2">图片消息</a-radio>
                  <a-radio :value="3" v-if="set_type === 'h5'"
                    >图文消息</a-radio
                  >
                  <a-radio :value="5" v-if="set_type === 'mini'"
                    >小程序卡片</a-radio
                  >
                </a-radio-group>
              </div>

              <div v-if="contentData[content_index_select].config.type == 1">
                <a-textarea
                  v-model="contentData[content_index_select].config.content"
                  placeholder="请输入文本消息内容"
                  :auto-size="{ minRows: 12, maxRows: 25 }"
                  style="width: 100%"
                  @blur="campaignNameBlur($event, 2)"
                  ref="focusB"
                />
                <!-- <pre type="text" style="flex: 1 1 0%;padding: 0.25em 0.5em;height: 100%;line-height: 1.5;overflow-wrap: break-word;overflow: hidden scroll;text-align: left;white-space: pre-wrap;">
							亲爱的用户，请按下方提示继续阅读「🔥宋小书」
							🔴回复数字"1"，继续阅读【宋小书】的精彩故事！
							🔴回复数字"1"，继续阅读【宋小书】的精彩故事！
							点击左下角的“⌨️”↙↙↙即可【回复数字】
							</pre> -->
              </div>

              <div
                v-if="contentData[content_index_select].config.type == 2"
                style="display: flex"
              >
                <div style="margin-right: 20px">图片</div>

                <a-upload
                  v-if="page_type != 'config-template'"
                  accept="image/*"
                  name="image"
                  class="avatar-uploader"
                  :show-upload-list="false"
                  :action="`${$http.excel_url}api/platform/gzh/upload-material`"
                  :data="{
                    id: r_gzh_id,
                  }"
                  :headers="{
                    Authorization: headers_token,
                  }"
                  :withCredentials="true"
                  method="post"
                  :before-upload="beforeUpload"
                  @change="uploadChange"
                >
                  <div
                    style="
                      border: 1px dashed #d9d9d9;
                      cursor: pointer;
                      width: 300px;
                    "
                  >
                    <img
                      v-if="
                        contentData[content_index_select].config.media_id_url
                      "
                      :src="
                        contentData[content_index_select].config.media_id_url
                      "
                      style="width: 100%; height: 150px; object-fit: contain"
                      alt=""
                    />
                    <div
                      v-else
                      style="
                        height: 150px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        color: #999;
                      "
                    >
                      <div style="text-align: center">
                        <a-icon
                          :type="e_img_loading ? 'loading' : 'plus'"
                          style="font-size: 22px"
                        />
                        <div>图片上传</div>
                      </div>
                    </div>
                  </div>
                </a-upload>

                <a-upload
                  v-else-if="page_type == 'config-template'"
                  accept="image/*"
                  name="file"
                  class="avatar-uploader"
                  :show-upload-list="false"
                  :action="`${$http.excel_url}api/common/upload-image`"
                  :data="{
                    type: 5,
                  }"
                  :headers="{
                    Authorization: headers_token,
                  }"
                  :withCredentials="true"
                  method="post"
                  :before-upload="beforeUpload"
                  @change="uploadChange"
                >
                  <div
                    style="
                      border: 1px dashed #d9d9d9;
                      cursor: pointer;
                      width: 300px;
                    "
                  >
                    <img
                      v-if="
                        contentData[content_index_select].config.media_id_url
                      "
                      :src="
                        contentData[content_index_select].config.media_id_url
                      "
                      style="width: 100%; height: 150px; object-fit: contain"
                      alt=""
                    />
                    <div
                      v-else
                      style="
                        height: 150px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        color: #999;
                      "
                    >
                      <div style="text-align: center">
                        <a-icon
                          :type="e_img_loading ? 'loading' : 'plus'"
                          style="font-size: 22px"
                        />
                        <div>图片上传</div>
                      </div>
                    </div>
                  </div>
                </a-upload>
              </div>

              <template
                v-if="contentData[content_index_select].config.type == 3"
              >
                <div class="form-cell-box">
                  <div class="class-title">消息标题</div>
                  <a-input
                    v-model="contentData[content_index_select].config.title"
                    @blur="campaignNameBlur($event, 3)"
                    ref="focusC"
                    placeholder="请输入消息标题"
                    :style="{ width: modal_width + 'px' }"
                  />
                </div>
                <div class="form-cell-box">
                  <div class="class-title">消息描述</div>
                  <a-input
                    v-model="
                      contentData[content_index_select].config.description
                    "
                    @blur="campaignNameBlur($event, 4)"
                    ref="focusD"
                    placeholder="请输入消息描述"
                    :style="{ width: modal_width + 'px' }"
                  />
                </div>
                <div class="form-cell-box">
                  <div class="class-title">消息图片</div>
                  <!-- <gzhMsgImgUpload @img-Upload-Handl e="imgUploadHandle"></gzhMsgImgUpload> -->
                  <div
                    style="
                      border: 1px dashed #d9d9d9;
                      cursor: pointer;
                      width: 150px;
                    "
                  >
                    <a-upload
                      accept="image/*"
                      name="file"
                      class="avatar-uploader"
                      :show-upload-list="false"
                      :action="`${$http.excel_url}api/common/upload-image`"
                      :data="{
                        type: 5,
                      }"
                      :headers="{
                        Authorization: headers_token,
                      }"
                      :withCredentials="true"
                      method="post"
                      :before-upload="txtimgBeforeUpload"
                      @change="txtimgUploadChange"
                    >
                      <div
                        class="type-3"
                        style="
                          border: 1px dashed #d9d9d9;
                          cursor: pointer;
                          width: 150px;
                          position: relative;
                        "
                      >
                        <img
                          v-if="contentData[content_index_select].config.image"
                          :src="contentData[content_index_select].config.image"
                          style="
                            width: 100%;
                            height: 150px;
                            object-fit: contain;
                          "
                          alt=""
                        />
                        <div
                          v-else
                          style="
                            height: 150px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            color: #999;
                          "
                        >
                          <div style="text-align: center">
                            <a-icon
                              :type="e_img_loading ? 'loading' : 'plus'"
                              style="font-size: 22px"
                            />
                            <div>图片上传</div>
                          </div>
                        </div>

                        <div
                          v-if="contentData[content_index_select].config.image"
                          class="cover-handle"
                        >
                          <div
                            @click.stop="cutCover(1)"
                            style="
                              color: #fff;
                              text-align: center;
                              cursor: pointer;
                            "
                          >
                            <a-icon style="font-size: 18px" type="scissor" />
                            <div>裁剪封面</div>
                          </div>
                          <div
                            style="
                              color: #fff;
                              text-align: center;
                              cursor: pointer;
                            "
                          >
                            <a-icon style="font-size: 18px" type="swap" />
                            <div>更换封面</div>
                          </div>
                        </div>
                      </div>
                    </a-upload>
                  </div>
                </div>
                <div class="form-cell-box">
                  <div class="class-title">消息链接URL</div>
                  <a-input
                    v-model="contentData[content_index_select].config.url"
                    @blur="campaignNameBlur($event, 5)"
                    ref="focusE"
                    placeholder="请输入消息链接URL"
                    :style="{ width: modal_width + 'px' }"
                  />
                </div>
              </template>

              <template
                v-if="contentData[content_index_select].config.type == 5"
              >
                <div class="form-cell-box">
                  <div class="class-title">小程序标题</div>
                  <a-input
                    v-model="contentData[content_index_select].config.title"
                    @blur="campaignNameBlur($event, 9)"
                    ref="focusI"
                    placeholder="请输入小程序标题"
                    :style="{ width: modal_width + 'px' }"
                  />
                </div>
                <div class="form-cell-box">
                  <div class="class-title">小程序APPID</div>
                  <a-input
                    v-model="contentData[content_index_select].config.appid"
                    @blur="campaignNameBlur($event, 50)"
                    ref="focusLL"
                    placeholder="请输入小程序APPID"
                    :style="{ width: modal_width + 'px' }"
                  />
                </div>

                <div class="form-cell-box">
                  <div class="class-title">小程序路径</div>
                  <a-input
                    v-model="contentData[content_index_select].config.pagepath"
                    @blur="campaignNameBlur($event, 51)"
                    ref="focusZZ"
                    placeholder="请输入小程序路径"
                    :style="{ width: modal_width + 'px' }"
                  />
                </div>

                <div class="form-cell-box">
                  <div class="class-title">消息封面</div>
                  <div
                    style="
                      border: 1px dashed #d9d9d9;
                      cursor: pointer;
                      width: 150px;
                    "
                  >
                    <a-upload
                      v-if="page_type == 'config-template'"
                      accept="image/*"
                      name="file"
                      class="avatar-uploader"
                      :show-upload-list="false"
                      :action="`${$http.excel_url}api/common/upload-image`"
                      :data="{
                        type: 5,
                      }"
                      :headers="{
                        Authorization: headers_token,
                      }"
                      :withCredentials="true"
                      method="post"
                      :before-upload="txtimgBeforeUpload"
                      @change="txtimgUploadChange"
                    >
                      <div
                        class="type-3"
                        style="
                          border: 1px dashed #d9d9d9;
                          cursor: pointer;
                          width: 150px;
                          position: relative;
                        "
                      >
                        <img
                          v-if="
                            contentData[content_index_select].config
                              .thumb_media_id_url
                          "
                          :src="
                            contentData[content_index_select].config
                              .thumb_media_id_url
                          "
                          style="
                            width: 100%;
                            height: 150px;
                            object-fit: contain;
                          "
                          alt=""
                        />
                        <div
                          v-else
                          style="
                            height: 150px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            color: #999;
                          "
                        >
                          <div style="text-align: center">
                            <a-icon
                              :type="e_img_loading ? 'loading' : 'plus'"
                              style="font-size: 22px"
                            />
                            <div>图片上传</div>
                          </div>
                        </div>

                        <div
                          v-if="contentData[content_index_select].config.image"
                          class="cover-handle"
                        >
                          <div
                            @click.stop="cutCover(2)"
                            style="
                              color: #fff;
                              text-align: center;
                              cursor: pointer;
                            "
                          >
                            <a-icon style="font-size: 18px" type="scissor" />
                            <div>裁剪封面</div>
                          </div>
                          <div
                            style="
                              color: #fff;
                              text-align: center;
                              cursor: pointer;
                            "
                          >
                            <a-icon style="font-size: 18px" type="swap" />
                            <div>更换封面</div>
                          </div>
                        </div>
                      </div>
                    </a-upload>

                    <a-upload
                      v-if="page_type != 'config-template'"
                      accept="image/*"
                      name="image"
                      class="avatar-uploader"
                      :show-upload-list="false"
                      :action="`${$http.excel_url}api/platform/gzh/upload-material`"
                      :data="{
                        id: r_gzh_id,
                      }"
                      :headers="{
                        Authorization: headers_token,
                      }"
                      :withCredentials="true"
                      method="post"
                      :before-upload="beforeUpload"
                      @change="uploadChange"
                    >
                      <div
                        class="type-3"
                        style="
                          border: 1px dashed #d9d9d9;
                          cursor: pointer;
                          width: 150px;
                          position: relative;
                        "
                      >
                        <img
                          v-if="
                            contentData[content_index_select].config
                              .thumb_media_id_url
                          "
                          :src="
                            contentData[content_index_select].config
                              .thumb_media_id_url
                          "
                          style="
                            width: 100%;
                            height: 150px;
                            object-fit: contain;
                          "
                          alt=""
                        />
                        <div
                          v-else
                          style="
                            height: 150px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            color: #999;
                          "
                        >
                          <div style="text-align: center">
                            <a-icon
                              :type="e_img_loading ? 'loading' : 'plus'"
                              style="font-size: 22px"
                            />
                            <div>图片上传</div>
                          </div>
                        </div>
                      </div>
                    </a-upload>
                  </div>
                </div>
              </template>

              <!--  -->
            </template>

            <!-- 跳转网页 -->
            <template
              v-else-if="contentData[content_index_select].type == 'view'"
            >
              <div style="font-weight: 600; margin-bottom: 20px">
                点击菜单会访问链接
              </div>
              <div class="form-cell-box">
                <div style="margin-right: 20px">网页链接：</div>
                <a-input
                  v-model="contentData[content_index_select].url"
                  @blur="campaignNameBlur($event, 6)"
                  ref="focusF"
                  placeholder="请输入跳转的网页链接"
                  style="width: 410px"
                />
              </div>
            </template>

            <!-- 跳转小程序 -->
            <template
              v-else-if="
                contentData[content_index_select].type == 'miniprogram'
              "
            >
              <div style="font-weight: 600; margin-bottom: 20px">
                点击菜单，会跳转到以下小程序。要求：小程序与公众号关联
              </div>
              <div class="form-cell-box">
                <div style="margin-right: 20px; width: 70px">APPID：</div>
                <a-input
                  @blur="campaignNameBlur($event, 13)"
                  ref="focusM"
                  v-model="contentData[content_index_select].appid"
                  placeholder="请输入APPID"
                  style="width: 410px"
                />
              </div>
              <div class="form-cell-box">
                <div style="margin-right: 20px; width: 70px">页面路径：</div>
                <a-input
                  @blur="campaignNameBlur($event, 14)"
                  ref="focusN"
                  v-model="contentData[content_index_select].pagepath"
                  placeholder="小程序的页面路径，例如：pages/inedx/reader?book_id=123"
                  style="width: 410px"
                />
              </div>
              <div class="form-cell-box">
                <div style="margin-right: 20px; width: 70px">备用页面：</div>
                <a-input
                  @blur="campaignNameBlur($event, 15)"
                  ref="focusO"
                  v-model="contentData[content_index_select].url"
                  placeholder="备用页面链接。老版本微信不支持小程序，会跳转到这个链接"
                  style="width: 410px"
                />
              </div>
            </template>
          </div>

          <a-button @click="delContentA" style="margin-left: 35px" type="danger"
            >删除当前菜单项</a-button
          >
        </div>

        <!-- 子菜单 -->
        <div
          v-else-if="
            contentData.length > 0 &&
            contentData[content_index_select].show_type == 3
          "
          style="width: 100%; height: 100%; padding: 30px 30px 30px 15px"
        >
          <div class="form-cell-box">
            <div class="class-title">子菜单名称</div>
            <a-input
              v-model="
                contentData[content_index_select].sub_button[
                  contentData[content_index_select].second_index
                ].name
              "
              @blur="campaignNameBlur($event, 7)"
              ref="focusG"
              placeholder="子菜单名称"
              style="width: 300px"
            />
          </div>

          <div class="form-cell-box">
            <div class="class-title">子菜单内容</div>
            <div>
              <a-radio-group
                @change="onChangeH"
                name="radioGroup"
                :value="
                  contentData[content_index_select].sub_button[
                    contentData[content_index_select].second_index
                  ].type
                "
              >
                <a-radio value="click">发送消息</a-radio>
                <a-radio value="view" v-if="set_type === 'h5'"
                  >跳转网页</a-radio
                >
                <a-radio value="miniprogram" v-if="set_type === 'mini'"
                  >跳转小程序</a-radio
                >
              </a-radio-group>
            </div>
          </div>

          <div
            style="
              margin-left: 15px;
              margin-bottom: 30px;
              border: 1px solid #e1e1e1;
              padding: 25px;
            "
          >
            <template
              v-if="
                contentData[content_index_select].sub_button[
                  contentData[content_index_select].second_index
                ].type == 'click'
              "
            >
              <div style="margin-bottom: 20px">
                <a-radio-group
                  @change="onChangeI"
                  name="radioGroup"
                  :value="
                    contentData[content_index_select].sub_button[
                      contentData[content_index_select].second_index
                    ].config.type
                  "
                >
                  <a-radio :value="1">文本消息</a-radio>
                  <a-radio :value="2">图片消息</a-radio>
                  <a-radio :value="3" v-if="set_type === 'h5'"
                    >图文消息</a-radio
                  >
                  <a-radio :value="5" v-if="set_type === 'mini'"
                    >小程序卡片</a-radio
                  >
                </a-radio-group>
              </div>

              <div
                v-if="
                  contentData[content_index_select].sub_button[
                    contentData[content_index_select].second_index
                  ].config.type == 1
                "
              >
                <a-textarea
                  v-model="
                    contentData[content_index_select].sub_button[
                      contentData[content_index_select].second_index
                    ].config.content
                  "
                  placeholder="请输入文本消息内容"
                  :auto-size="{ minRows: 12, maxRows: 25 }"
                  style="width: 100%"
                  @blur="campaignNameBlur($event, 8)"
                  ref="focusH"
                />
                <!-- <pre type="text" style="flex: 1 1 0%;padding: 0.25em 0.5em;height: 100%;line-height: 1.5;overflow-wrap: break-word;overflow: hidden scroll;text-align: left;white-space: pre-wrap;">
							亲爱的用户，请按下方提示继续阅读「🔥宋小书」
							🔴回复数字"1"，继续阅读【宋小书】的精彩故事！
							🔴回复数字"1"，继续阅读【宋小书】的精彩故事！
							点击左下角的“⌨️”↙↙↙即可【回复数字】
							</pre> -->
              </div>

              <div
                v-if="
                  contentData[content_index_select].sub_button[
                    contentData[content_index_select].second_index
                  ].config.type == 2
                "
                style="display: flex"
              >
                <div style="margin-right: 20px">图片</div>

                <a-upload
                  v-if="page_type != 'config-template'"
                  accept="image/*"
                  name="image"
                  class="avatar-uploader"
                  :show-upload-list="false"
                  :action="`${$http.excel_url}api/platform/gzh/upload-material`"
                  :data="{
                    id: r_gzh_id,
                  }"
                  :headers="{
                    Authorization: headers_token,
                  }"
                  :withCredentials="true"
                  method="post"
                  :before-upload="beforeUpload"
                  @change="uploadChange"
                >
                  <div
                    style="
                      border: 1px dashed #d9d9d9;
                      cursor: pointer;
                      width: 300px;
                    "
                  >
                    <img
                      v-if="
                        contentData[content_index_select].sub_button[
                          contentData[content_index_select].second_index
                        ].config.media_id_url
                      "
                      :src="
                        contentData[content_index_select].sub_button[
                          contentData[content_index_select].second_index
                        ].config.media_id_url
                      "
                      style="width: 100%; height: 150px; object-fit: contain"
                      alt=""
                    />
                    <div
                      v-else
                      style="
                        height: 150px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        color: #999;
                      "
                    >
                      <div style="text-align: center">
                        <a-icon
                          :type="e_img_loading ? 'loading' : 'plus'"
                          style="font-size: 22px"
                        />
                        <div>图片上传</div>
                      </div>
                    </div>
                  </div>
                </a-upload>

                <a-upload
                  v-else-if="page_type == 'config-template'"
                  accept="image/*"
                  name="file"
                  class="avatar-uploader"
                  :show-upload-list="false"
                  :action="`${$http.excel_url}api/common/upload-image`"
                  :data="{
                    type: 5,
                  }"
                  :headers="{
                    Authorization: headers_token,
                  }"
                  :withCredentials="true"
                  method="post"
                  :before-upload="beforeUpload"
                  @change="uploadChange"
                >
                  <div
                    style="
                      border: 1px dashed #d9d9d9;
                      cursor: pointer;
                      width: 300px;
                    "
                  >
                    <img
                      v-if="
                        contentData[content_index_select].sub_button[
                          contentData[content_index_select].second_index
                        ].config.media_id_url
                      "
                      :src="
                        contentData[content_index_select].sub_button[
                          contentData[content_index_select].second_index
                        ].config.media_id_url
                      "
                      style="width: 100%; height: 150px; object-fit: contain"
                      alt=""
                    />
                    <div
                      v-else
                      style="
                        height: 150px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        color: #999;
                      "
                    >
                      <div style="text-align: center">
                        <a-icon
                          :type="e_img_loading ? 'loading' : 'plus'"
                          style="font-size: 22px"
                        />
                        <div>图片上传</div>
                      </div>
                    </div>
                  </div>
                </a-upload>
              </div>

              <template
                v-if="
                  contentData[content_index_select].sub_button[
                    contentData[content_index_select].second_index
                  ].config.type == 3
                "
              >
                <div class="form-cell-box">
                  <div class="class-title">消息标题</div>
                  <a-input
                    v-model="
                      contentData[content_index_select].sub_button[
                        contentData[content_index_select].second_index
                      ].config.title
                    "
                    @blur="campaignNameBlur($event, 9)"
                    ref="focusI"
                    placeholder="请输入消息标题"
                    :style="{ width: modal_width + 'px' }"
                  />
                </div>
                <div class="form-cell-box">
                  <div class="class-title">消息描述</div>
                  <a-input
                    v-model="
                      contentData[content_index_select].sub_button[
                        contentData[content_index_select].second_index
                      ].config.description
                    "
                    @blur="campaignNameBlur($event, 10)"
                    ref="focusJ"
                    placeholder="请输入消息描述"
                    :style="{ width: modal_width + 'px' }"
                  />
                </div>
                <div class="form-cell-box">
                  <div class="class-title">消息图片</div>
                  <div
                    style="
                      border: 1px dashed #d9d9d9;
                      cursor: pointer;
                      width: 150px;
                    "
                  >
                    <a-upload
                      accept="image/*"
                      name="file"
                      class="avatar-uploader"
                      :show-upload-list="false"
                      :action="`${$http.excel_url}api/common/upload-image`"
                      :data="{
                        type: 5,
                      }"
                      :headers="{
                        Authorization: headers_token,
                      }"
                      :withCredentials="true"
                      method="post"
                      :before-upload="txtimgBeforeUpload"
                      @change="txtimgUploadChange"
                    >
                      <div
                        class="type-3"
                        style="
                          border: 1px dashed #d9d9d9;
                          cursor: pointer;
                          width: 150px;
                          position: relative;
                        "
                      >
                        <img
                          v-if="
                            contentData[content_index_select].sub_button[
                              contentData[content_index_select].second_index
                            ].config.image
                          "
                          :src="
                            contentData[content_index_select].sub_button[
                              contentData[content_index_select].second_index
                            ].config.image
                          "
                          style="
                            width: 100%;
                            height: 150px;
                            object-fit: contain;
                          "
                          alt=""
                        />
                        <div
                          v-else
                          style="
                            height: 150px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            color: #999;
                          "
                        >
                          <div style="text-align: center">
                            <a-icon
                              :type="e_img_loading ? 'loading' : 'plus'"
                              style="font-size: 22px"
                            />
                            <div>图片上传</div>
                          </div>
                        </div>

                        <div
                          v-if="
                            contentData[content_index_select].sub_button[
                              contentData[content_index_select].second_index
                            ].config.image
                          "
                          class="cover-handle"
                        >
                          <div
                            @click.stop="cutCover(2)"
                            style="
                              color: #fff;
                              text-align: center;
                              cursor: pointer;
                            "
                          >
                            <a-icon style="font-size: 18px" type="scissor" />
                            <div>裁剪封面</div>
                          </div>
                          <div
                            style="
                              color: #fff;
                              text-align: center;
                              cursor: pointer;
                            "
                          >
                            <a-icon style="font-size: 18px" type="swap" />
                            <div>更换封面</div>
                          </div>
                        </div>
                      </div>
                    </a-upload>
                  </div>
                </div>
                <div class="form-cell-box">
                  <div class="class-title">消息链接URL</div>
                  <a-input
                    v-model="
                      contentData[content_index_select].sub_button[
                        contentData[content_index_select].second_index
                      ].config.url
                    "
                    @blur="campaignNameBlur($event, 11)"
                    ref="focusK"
                    placeholder="请输入消息链接URL"
                    :style="{ width: modal_width + 'px' }"
                  />
                </div>
              </template>

              <template
                v-if="
                  contentData[content_index_select].sub_button[
                    contentData[content_index_select].second_index
                  ].config.type == 5
                "
              >
                <div class="form-cell-box">
                  <div class="class-title">小程序标题</div>
                  <a-input
                    v-model="
                      contentData[content_index_select].sub_button[
                        contentData[content_index_select].second_index
                      ].config.title
                    "
                    @blur="campaignNameBlur($event, 9)"
                    ref="focusI"
                    placeholder="请输入小程序标题"
                    :style="{ width: modal_width + 'px' }"
                  />
                </div>
                <div class="form-cell-box">
                  <div class="class-title">小程序APPID</div>
                  <a-input
                    v-model="
                      contentData[content_index_select].sub_button[
                        contentData[content_index_select].second_index
                      ].config.appid
                    "
                    @blur="campaignNameBlur($event, 50)"
                    ref="focusLL"
                    placeholder="请输入小程序APPID"
                    :style="{ width: modal_width + 'px' }"
                  />
                </div>

                <div class="form-cell-box">
                  <div class="class-title">小程序路径</div>
                  <a-input
                    v-model="
                      contentData[content_index_select].sub_button[
                        contentData[content_index_select].second_index
                      ].config.pagepath
                    "
                    @blur="campaignNameBlur($event, 51)"
                    ref="focusZZ"
                    placeholder="请输入小程序路径"
                    :style="{ width: modal_width + 'px' }"
                  />
                </div>

                <div class="form-cell-box">
                  <div class="class-title">消息封面</div>
                  <div
                    style="
                      border: 1px dashed #d9d9d9;
                      cursor: pointer;
                      width: 150px;
                    "
                  >
                    <a-upload
                      v-if="page_type == 'config-template'"
                      accept="image/*"
                      name="file"
                      class="avatar-uploader"
                      :show-upload-list="false"
                      :action="`${$http.excel_url}api/common/upload-image`"
                      :data="{
                        type: 5,
                      }"
                      :headers="{
                        Authorization: headers_token,
                      }"
                      :withCredentials="true"
                      method="post"
                      :before-upload="txtimgBeforeUpload"
                      @change="txtimgUploadChange"
                    >
                      <div
                        class="type-3"
                        style="
                          border: 1px dashed #d9d9d9;
                          cursor: pointer;
                          width: 150px;
                          position: relative;
                        "
                      >
                        <img
                          v-if="
                            contentData[content_index_select].sub_button[
                              contentData[content_index_select].second_index
                            ].config.thumb_media_id_url
                          "
                          :src="
                            contentData[content_index_select].sub_button[
                              contentData[content_index_select].second_index
                            ].config.thumb_media_id_url
                          "
                          style="
                            width: 100%;
                            height: 150px;
                            object-fit: contain;
                          "
                          alt=""
                        />
                        <div
                          v-else
                          style="
                            height: 150px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            color: #999;
                          "
                        >
                          <div style="text-align: center">
                            <a-icon
                              :type="e_img_loading ? 'loading' : 'plus'"
                              style="font-size: 22px"
                            />
                            <div>图片上传</div>
                          </div>
                        </div>

                        <div
                          v-if="
                            contentData[content_index_select].sub_button[
                              contentData[content_index_select].second_index
                            ].config.image
                          "
                          class="cover-handle"
                        >
                          <div
                            @click.stop="cutCover(2)"
                            style="
                              color: #fff;
                              text-align: center;
                              cursor: pointer;
                            "
                          >
                            <a-icon style="font-size: 18px" type="scissor" />
                            <div>裁剪封面</div>
                          </div>
                          <div
                            style="
                              color: #fff;
                              text-align: center;
                              cursor: pointer;
                            "
                          >
                            <a-icon style="font-size: 18px" type="swap" />
                            <div>更换封面</div>
                          </div>
                        </div>
                      </div>
                    </a-upload>

                    <a-upload
                      v-if="page_type != 'config-template'"
                      accept="image/*"
                      name="image"
                      class="avatar-uploader"
                      :show-upload-list="false"
                      :action="`${$http.excel_url}api/platform/gzh/upload-material`"
                      :data="{
                        id: r_gzh_id,
                      }"
                      :headers="{
                        Authorization: headers_token,
                      }"
                      :withCredentials="true"
                      method="post"
                      :before-upload="beforeUpload"
                      @change="uploadChange"
                    >
                      <div
                        class="type-3"
                        style="
                          border: 1px dashed #d9d9d9;
                          cursor: pointer;
                          width: 150px;
                          position: relative;
                        "
                      >
                        <img
                          v-if="
                            contentData[content_index_select].sub_button[
                              contentData[content_index_select].second_index
                            ].config.thumb_media_id_url
                          "
                          :src="
                            contentData[content_index_select].sub_button[
                              contentData[content_index_select].second_index
                            ].config.thumb_media_id_url
                          "
                          style="
                            width: 100%;
                            height: 150px;
                            object-fit: contain;
                          "
                          alt=""
                        />
                        <div
                          v-else
                          style="
                            height: 150px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            color: #999;
                          "
                        >
                          <div style="text-align: center">
                            <a-icon
                              :type="e_img_loading ? 'loading' : 'plus'"
                              style="font-size: 22px"
                            />
                            <div>图片上传</div>
                          </div>
                        </div>
                      </div>
                    </a-upload>
                  </div>
                </div>
              </template>
            </template>

            <!-- 跳转网页 -->
            <template
              v-else-if="
                contentData[content_index_select].sub_button[
                  contentData[content_index_select].second_index
                ].type == 'view'
              "
            >
              <div style="font-weight: 600; margin-bottom: 20px">
                点击菜单会访问链接
              </div>
              <div class="form-cell-box">
                <div style="margin-right: 20px">网页链接：</div>
                <a-input
                  v-model="
                    contentData[content_index_select].sub_button[
                      contentData[content_index_select].second_index
                    ].url
                  "
                  @blur="campaignNameBlur($event, 12)"
                  ref="focusL"
                  placeholder="请输入跳转的网页链接"
                  style="width: 410px"
                />
              </div>
            </template>

            <!-- 跳转小程序 -->
            <template
              v-else-if="
                contentData[content_index_select].sub_button[
                  contentData[content_index_select].second_index
                ].type == 'miniprogram'
              "
            >
              <div style="font-weight: 600; margin-bottom: 20px">
                点击菜单，会跳转到以下小程序。要求：小程序与公众号关联
              </div>
              <div class="form-cell-box">
                <div style="margin-right: 20px; width: 70px">APPID：</div>
                <a-input
                  @blur="campaignNameBlur($event, 16)"
                  ref="focusP"
                  v-model="
                    contentData[content_index_select].sub_button[
                      contentData[content_index_select].second_index
                    ].appid
                  "
                  placeholder="请输入APPID"
                  style="width: 410px"
                />
              </div>
              <div class="form-cell-box">
                <div style="margin-right: 20px; width: 70px">页面路径：</div>
                <a-input
                  @blur="campaignNameBlur($event, 17)"
                  ref="focusQ"
                  v-model="
                    contentData[content_index_select].sub_button[
                      contentData[content_index_select].second_index
                    ].pagepath
                  "
                  placeholder="小程序的页面路径，例如：pages/inedx/reader?book_id=123"
                  style="width: 410px"
                />
              </div>
              <div class="form-cell-box">
                <div style="margin-right: 20px; width: 70px">备用页面：</div>
                <a-input
                  @blur="campaignNameBlur($event, 18)"
                  ref="focusR"
                  v-model="
                    contentData[content_index_select].sub_button[
                      contentData[content_index_select].second_index
                    ].url
                  "
                  placeholder="备用页面链接。老版本微信不支持小程序，会跳转到这个链接"
                  style="width: 410px"
                />
              </div>
            </template>
          </div>

          <a-button @click="delContentB" style="margin-left: 35px" type="danger"
            >删除子菜单</a-button
          >
        </div>
      </div>
    </div>

    <a-button
      v-if="page_type == 'config-template2'"
      @click="sendButton"
      style="margin-right: 30px; margin-left: 17px; margin-top: 20px"
      type="primary"
      >保存并发布</a-button
    >
    <a-modal
      title="同步到其他公众号"
      :visible="sync_visible"
      :confirm-loading="sync_confirmLoading"
      @ok="syncHandleOk"
      @cancel="syncHandleCancel"
      width="1100px"
    >
      <div>
        <div style="margin-bottom: 15px; font-size: 16px; color: #333">
          选择公众号（当前渠道：{{ sync_channel_name }}）
        </div>
        <div style="max-height: 300px; overflow-y: overlay">
          <div
            v-for="(item, index) in syncGzhData"
            :key="index"
            style="margin-bottom: 25px"
          >
            <a-checkbox
              :indeterminate="item.indeterminate_all"
              :checked="item.checked_all"
              @change="onCheckAllChange($event, item, index)"
            >
              {{ item.label }}
            </a-checkbox>
            <div
              style="
                display: flex;
                align-items: center;
                flex-wrap: wrap;
                margin-left: 20px;
                margin-top: 10px;
              "
            >
              <div
                v-for="(item_z, index_z) in item.value"
                :key="index_z"
                style="margin-bottom: 5px; margin-right: 10px"
              >
                <a-checkbox
                  :checked="item_z.checked_z"
                  @change="onCheckChange($event, item_z, index, index_z)"
                >
                  {{ item_z.gzh_name }}
                </a-checkbox>
              </div>
            </div>
          </div>
        </div>
      </div>
    </a-modal>

    <!-- 图片裁切 -->
    <cropperImgModal
      ref="getCropperImg"
      @cropper-ok="cropperOk"
    ></cropperImgModal>

    <!-- 加载中 -->
    <div class="loading-box" v-if="search_button_loading">
      <a-spin size="large" />
    </div>
  </div>
</template>

<script>
import { gzhMenuAdd, gzhMenuInfo } from "@/request/api";
import cropperImgModal from "./cropperImgModal";
// import gzhMsgImgUpload from "./gzhMsgImgUpload";
export default {
  name: "pageGzhMenu_",
  props: ["page_type", "set_type"],
  components: {
    cropperImgModal,
    // gzhMsgImgUpload,
  },
  data() {
    return {
      search_button_loading: false,

      modal_width: 360,

      contentData: [],
      content_index_select: 0, // 当前选中的第几个菜单

      title_gzh_name: "", // 当前选择的公众号名字
      r_gzh_id: null, // 当前选择的公众号ID

      headers_token: "", // 图片上传用的token
      e_img_loading: false,

      cut_type: "", // 裁切的图片类型

      right_content_height: 300, // 右侧内容盒子的高度

      // 同步到其他公众号
      sync_visible: false,
      sync_confirmLoading: false,
      sync_channel_name: "", // 渠道名字
      syncGzhData: [],

      gzh_name: "", // 公众号名字

      delA_control: true, // 删除一级菜单的节流控制

      gzhTabData: [],
      originalTabObj: {}, // 第一个公众号下的数据
      gzhTab_control: 1, // 控制，判断是不是第一次

      campaignNameIndex: 0,
      campaign_type: 0, // 用于判断是哪个输入框要插入文本
    };
  },
  mounted() {
    let that = this;

    // 图片上传用的token
    this.headers_token = "Bearer " + localStorage.getItem("access_token");

    let hhh =
      document.body.clientHeight -
      65 -
      50 -
      20 -
      (27 + 9) -
      (32 + 20 + 20) -
      (32 + 20);
    that.right_content_height = hhh < 608 ? hhh : 608;
    // console.log("right_content_height", that.right_content_height);
  },
  methods: {
    setContentData(data) {
      if (data && data.length > 0) {
        this.content_index_select = 0;
      }
      const _temp = JSON.parse(JSON.stringify(data));
      for (let index = 0; index < _temp.length; index += 1) {
        const item = _temp[index];
        item.second_index = -1;
        item.show_type = 1;
      }
      // console.log(data)
      this.contentData = _temp;
    },
    // 获取详情
    getInfo(gzh_id, item, gzh_name) {
      let that = this;
      that.r_gzh_id = gzh_id;
      that.gzh_name = gzh_name;
      that.content_index_select = 0; // 这里要重置为0，不然的话当已经创建了3个一级菜单，然后返回的详情只有一个菜单时，会报错
      that.search_button_loading = true;

      gzhMenuInfo({
        gzh_id: that.r_gzh_id,
        content_type: that.set_type === "h5" ? 1 : 2,
      })
        .then((res) => {
          if (
            res.data.code == 0 ||
            res.data.code == 200 ||
            res.data.code == 8011
          ) {
            if (
              Object.keys(res.data.data.info).length > 0 &&
              res.data.data.info.menu.button
            ) {
              let data = res.data.data.info.menu.button;

              let arr = [];
              data.forEach((res) => {
                let obj = {
                  url: "",
                  appid: "",
                  pagepath: "",

                  sub_button: [],
                  config: {
                    type: 1,
                    content: "",
                    media_id: "",
                    media_id_url: "",
                    title: "",
                    description: "",
                    url: "",
                    image: "",
                    appid: "",
                    pagepath: "",
                    thumb_media_id: "",
                    thumb_media_id_url: "",
                  },
                  second_index: -1, // 子菜单的索引
                  show_type: 2, // 右边内容的显示类型1为有子菜单，2为显示菜单内容，3为显示子菜单内容
                };

                obj.name = res.name;
                obj.type = res.type;
                if (res.type == "click") {
                  if (res.hasOwnProperty("config")) {
                    obj.config = res.config[0] || {};
                  }
                } else if (res.type == "view") {
                  obj.url = res.url;
                } else if (res.type == "miniprogram") {
                  obj.appid = res.appid;
                  obj.pagepath = res.pagepath;
                  obj.url = res.url;
                }

                if (
                  res.hasOwnProperty("sub_button") &&
                  res.sub_button.length > 0
                ) {
                  obj.show_type = 1;
                  res.sub_button.forEach((re_z) => {
                    let z_obj = {
                      url: "",
                      appid: "",
                      pagepath: "",

                      sub_button: [],
                      config: {
                        type: 1,
                        content: "",
                        media_id: "",
                        media_id_url: "",
                        title: "",
                        description: "",
                        url: "",
                        image: "",
                        appid: "",
                        pagepath: "",
                        thumb_media_id: "",
                        thumb_media_id_url: "",
                      },
                    };
                    z_obj.name = re_z.name;
                    z_obj.type = re_z.type;

                    if (re_z.type == "click") {
                      if (re_z.hasOwnProperty("config")) {
                        z_obj.config = re_z.config[0] || {};
                      }
                    } else if (re_z.type == "view") {
                      z_obj.url = re_z.url;
                    } else if (re_z.type == "miniprogram") {
                      z_obj.appid = re_z.appid;
                      z_obj.pagepath = re_z.pagepath;
                      z_obj.url = re_z.url;
                    }
                    obj.sub_button.push(z_obj);
                  });
                }

                arr.push(obj);
              });

              that.search_button_loading = false;

              that.contentData = arr;
            } else {
              that.search_button_loading = false;
              that.contentData = [];
            }
          } else {
            that.search_button_loading = false;
            that.$message.error(`错误：${res.data.msg}`);
          }
        })
        .catch((err) => {
          that.search_button_loading = false;
          that.$message.error(`网络错误`);
        });

      // 处理公众号分组的内容
      that.getSyncGzh(gzh_id, item);
    },
    // 获取详情-公众号配置模板
    getInfoTemplate(data) {
      let that = this;

      that.content_index_select = 0; // 这里要重置为0，不然的话当已经创建了3个一级菜单，然后返回的详情只有一个菜单时，会报错

      let arr = [];
      data.forEach((res) => {
        let obj = {
          url: "",
          appid: "",
          pagepath: "",

          sub_button: [],
          config: {
            type: 1,
            content: "",
            media_id: "",
            media_id_url: "",
            title: "",
            description: "",
            url: "",
            image: "",
            appid: "",
            pagepath: "",
            thumb_media_id: "",
            thumb_media_id_url: "",
          },
          second_index: -1, // 子菜单的索引
          show_type: 2, // 右边内容的显示类型1为有子菜单，2为显示菜单内容，3为显示子菜单内容
        };

        obj.name = res.name;
        obj.type = res.type;
        if (res.type == "click") {
          obj.config = res.config;
          if (obj.config.type == 1) {
            obj.config.content = decodeURIComponent(obj.config.content);
          }
        } else if (res.type == "view") {
          obj.url = res.url;
        } else if (res.type == "miniprogram") {
          obj.appid = res.appid;
          obj.pagepath = res.pagepath;
          obj.url = res.url;
        }

        if (res.hasOwnProperty("sub_button") && res.sub_button.length > 0) {
          obj.show_type = 1;
          res.sub_button.forEach((re_z) => {
            let z_obj = {
              url: "",
              appid: "",
              pagepath: "",

              sub_button: [],
              config: {
                type: 1,
                content: "",
                media_id: "",
                media_id_url: "",
                title: "",
                description: "",
                url: "",
                image: "",
                appid: "",
                pagepath: "",
                thumb_media_id: "",
                thumb_media_id_url: "",
              },
            };
            z_obj.name = re_z.name;
            z_obj.type = re_z.type;

            if (re_z.type == "click") {
              z_obj.config = re_z.config;
              if (z_obj.config.type == 1) {
                z_obj.config.content = decodeURIComponent(z_obj.config.content);
              }
            } else if (re_z.type == "view") {
              z_obj.url = re_z.url;
            } else if (re_z.type == "miniprogram") {
              z_obj.appid = re_z.appid;
              z_obj.pagepath = re_z.pagepath;
              z_obj.url = re_z.url;
            }
            obj.sub_button.push(z_obj);
          });
        }

        arr.push(obj);
      });

      that.search_button_loading = false;

      that.contentData = arr;
    },
    getSyncGzh(gzh_id, item) {
      let that = this;

      // 获取同步其他公众号弹窗的数据
      that.sync_channel_name = item.name || "";

      let copy_item = JSON.parse(JSON.stringify(item));
      let g_data = [];
      let arr = [];
      for (let key in copy_item.value) {
        let obj = {
          label: key,
          checked_all: false,
          indeterminate_all: false,
        };
        let del_index = -1; // 找出当前已选中公众号的数据，进行删除，不需要显示在弹窗里
        copy_item.value[key].forEach((res, index) => {
          if (res.id == gzh_id) {
            del_index = index;
          }

          // res.checked_z = false
          this.$set(res, "checked_z", false);
        });
        if (del_index > -1) {
          copy_item.value[key].splice(del_index, 1);
        }

        obj.value = copy_item.value[key];
        arr.push(obj);
      }
      console.log("arr", arr);
      that.syncGzhData = arr;
    },

    // 切换公众号
    onChangeTab(g_id, g_name) {
      this.gzh_name = g_name;
      this.r_gzh_id = g_id;
      let that = this;
      this.gzhTabData.forEach((res) => {
        if (res.gzh_id == g_id) {
          that.contentData = res.content;
        }
      });
    },
    onChangeB(e) {
      // 菜单内容/类型
      this.contentData[this.content_index_select].type = e.target.value;
    },
    onChangeC(e) {
      this.contentData[this.content_index_select].config.type = e.target.value;
    },
    onChangeH(e) {
      // 子菜单
      this.contentData[this.content_index_select].sub_button[
        this.contentData[this.content_index_select].second_index
      ].type = e.target.value;
    },
    onChangeI(e) {
      // 子菜单
      this.contentData[this.content_index_select].sub_button[
        this.contentData[this.content_index_select].second_index
      ].config.type = e.target.value;
    },
    // 添加按钮
    addButtonA() {
      let obj = {
        name: "",
        type: "click", // view-网页类型，click-点击类型，miniprogram-小程序类型
        key: 0, // 这个字段非click就不传。固定传0
        url: "",
        appid: "",
        pagepath: "",
        sub_button: [],
        config: {
          type: 1,
          content: "",
          media_id: "",
          media_id_url: "",
          title: "",
          description: "",
          url: "",
          image: "",
          appid: "",
          pagepath: "",
          thumb_media_id: "",
          thumb_media_id_url: "",
        },
        second_index: -1, // 子菜单的索引
        show_type: 2, // 右边内容的显示类型1为有子菜单，2为显示菜单内容，3为显示子菜单内容
      };
      this.contentData.push(obj);
      this.content_index_select = this.contentData.length - 1;
      console.log(this.content_index_select, `7778888`);
    },
    // 选择公众号菜单
    selectContent(item, index) {
      this.content_index_select = index;
      this.contentData.forEach((res) => {
        res.second_index = -1; // 子菜单的状态重置了，下面的一级菜单的状态也要重置，不然会报错
        if (res.sub_button.length > 0) {
          // 这里要重置所有一级菜单的状态，免得删除一级菜单的时候会报错
          res.show_type = 1;
        } else {
          res.show_type = 2;
        }
      });
    },
    // 删除一级菜单
    delContentA() {
      let that = this;
      if (this.delA_control) {
        // 节流，避免删除过快，出现多个内容在极短的时间内被删除，然后页面找不到内容显示，然后报错
        this.delA_control = false;

        if (this.contentData[this.content_index_select].sub_button.length > 1) {
          this.contentData[this.content_index_select].show_type = 1;
        } else {
          this.contentData[this.content_index_select].show_type = 2;
        }

        this.contentData.splice(this.content_index_select, 1);
        this.content_index_select = 0;

        this.$nextTick(() => {
          setTimeout(() => {
            that.delA_control = true;
          }, 500);
        });
      }
    },
    // 添加子集按钮
    addButtonB(index) {
      this.contentData.forEach((res) => {
        res.second_index = -1;
      });

      let obj = {
        name: "",
        type: "click",
        key: 0, // 这个字段非click就不传
        url: "",
        appid: "",
        pagepath: "",
        sub_button: [],
        config: {
          type: 1,
          content: "",
          media_id: "",
          media_id_url: "",
          title: "",
          description: "",
          url: "",
          image: "",
          appid: "",
          pagepath: "",
          thumb_media_id: "",
          thumb_media_id_url: "",
        },
      };
      this.contentData[index].sub_button.push(obj);
      this.contentData[index].second_index =
        this.contentData[index].sub_button.length - 1;

      this.content_index_select = index;
      this.contentData[index].show_type = 3;
    },
    // 切换子菜单
    secondContent(item, index, ite_z, inde_z) {
      // console.log(item, ite_z, inde_z);
      this.contentData.forEach((res) => {
        res.second_index = -1;
      });
      item.second_index = inde_z;
      this.content_index_select = index;
      this.contentData[index].show_type = 3;
    },

    // 图片上传 限制用户上传的图片格式和大小。
    beforeUpload(file) {
      console.log("beforeUpload", file);
      this.e_img_loading = true;

      if (this.contentData[this.content_index_select].sub_button.length > 0) {
        // 子菜单
        this.contentData[this.content_index_select].sub_button[
          this.contentData[this.content_index_select].second_index
        ].config.media_id_url = "";
      } else {
        // 一级菜单
        this.contentData[this.content_index_select].config.media_id_url = "";
      }

      const isJpgOrPng =
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg" ||
        file.type === "image/gif";
      if (!isJpgOrPng) {
        this.e_img_loading = false;
        this.$message.error("图片格式只能为：PNG、JPEG、JPG/GIF");
      }
      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!isLt2M) {
        this.e_img_loading = false;
        this.$message.error("图片大小不能超过10MB!");
      }
      return isJpgOrPng && isLt2M;
    },
    uploadChange(info) {
      console.log("这是多媒体图片请求", info);
      let that = this;

      if (info.file.status === "uploading") {
        return;
      }
      if (info.file.status === "done") {
        that.e_img_loading = false;
        if (info.file.response) {
          // 图片上传成功，有内容返回
          if (info.file.response.code == 0 || info.file.response.code == 200) {
            if (this.page_type != "config-template") {
              if (
                this.contentData[this.content_index_select].sub_button.length >
                0
              ) {
                // 子菜单
                if (this.set_type === "h5") {
                  this.contentData[this.content_index_select].sub_button[
                    this.contentData[this.content_index_select].second_index
                  ].config.media_id_url = info.file.response.data.data.url;

                  this.contentData[this.content_index_select].sub_button[
                    this.contentData[this.content_index_select].second_index
                  ].config.media_id = info.file.response.data.data.media_id;
                }
                if (this.set_type === "mini") {
                  this.contentData[this.content_index_select].sub_button[
                    this.contentData[this.content_index_select].second_index
                  ].config.thumb_media_id_url =
                    info.file.response.data.data.url;

                  this.contentData[this.content_index_select].sub_button[
                    this.contentData[this.content_index_select].second_index
                  ].config.thumb_media_id =
                    info.file.response.data.data.media_id;
                }
              } else {
                console.log(this.set_type);
                console.log(this.contentData[this.content_index_select].config);
                if (this.set_type === "h5") {
                  this.contentData[
                    this.content_index_select
                  ].config.media_id_url = info.file.response.data.data.url;
                  this.contentData[this.content_index_select].config.media_id =
                    info.file.response.data.data.media_id;
                }
                if (this.set_type === "mini") {
                  if (
                    this.contentData[this.content_index_select].config.type ===
                    2
                  ) {
                    this.contentData[
                      this.content_index_select
                    ].config.media_id_url = info.file.response.data.data.url;
                    this.contentData[
                      this.content_index_select
                    ].config.media_id = info.file.response.data.data.media_id;
                  }
                  if (
                    this.contentData[this.content_index_select].config.type ===
                    5
                  ) {
                    this.contentData[
                      this.content_index_select
                    ].config.thumb_media_id_url =
                      info.file.response.data.data.url;
                    this.contentData[
                      this.content_index_select
                    ].config.thumb_media_id =
                      info.file.response.data.data.media_id;
                  }
                }
              }
            } else if (this.page_type == "config-template") {
              if (
                this.contentData[this.content_index_select].sub_button.length >
                0
              ) {
                // 子菜单
                this.contentData[this.content_index_select].sub_button[
                  this.contentData[this.content_index_select].second_index
                ].config.media_id_url = info.file.response.data.url;
                this.contentData[this.content_index_select].sub_button[
                  this.contentData[this.content_index_select].second_index
                ].config.media_id = "";
              } else {
                this.contentData[
                  this.content_index_select
                ].config.media_id_url = info.file.response.data.url;
                this.contentData[this.content_index_select].config.media_id =
                  "";
              }
            }
          } else {
            that.$message.error(`错误：${info.file.response.msg}`);
          }
        } else {
          this.$message.error(`错误：图片上传失败`);
        }
      }

      if (info.file.status === "error") {
        // 上传失败

        this.loading = false;
        this.$message.error(`错误：图片上传失败`);
      }
    },

    // 图文消息上传
    txtimgBeforeUpload(file) {
      console.log("beforeUpload", file);
      this.e_img_loading = true;
      if (this.contentData[this.content_index_select].sub_button.length > 0) {
        // 子菜单
        this.contentData[this.content_index_select].sub_button[
          this.contentData[this.content_index_select].second_index
        ].config.image = "";
      } else {
        this.contentData[this.content_index_select].config.image = "";
      }

      const isJpgOrPng =
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg" ||
        file.type === "image/gif";
      if (!isJpgOrPng) {
        this.e_img_loading = false;
        this.$message.error("图片格式只能为：PNG、JPEG、JPG/GIF");
      }
      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!isLt2M) {
        this.e_img_loading = false;
        this.$message.error("图片大小不能超过10MB!");
      }
      return isJpgOrPng && isLt2M;
    },
    txtimgUploadChange(info) {
      console.log("图片请求1", info);
      console.log("图片请求1", this.set_type);
      let that = this;

      if (info.file.status === "uploading") {
        return;
      }
      if (info.file.status === "done") {
        that.e_img_loading = false;
        // console.log("图片请求done",info);
        if (info.file.response) {
          // 图片上传成功，有内容返回

          if (info.file.response.code == 0 || info.file.response.code == 200) {
            if (
              this.contentData[this.content_index_select].sub_button.length > 0
            ) {
              // 子菜单
              if (this.set_type === "h5") {
                this.contentData[this.content_index_select].sub_button[
                  this.contentData[this.content_index_select].second_index
                ].config.image = info.file.response.data.url;
              }
              if (this.set_type === "mini") {
                this.contentData[this.content_index_select].sub_button[
                  this.contentData[this.content_index_select].second_index
                ].config.thumb_media_id_url = info.file.response.data.url;
                this.contentData[this.content_index_select].sub_button[
                  this.contentData[this.content_index_select].second_index
                ].config.thumb_media_id = info.file.response.data.path;
              }
            } else {
              if (this.set_type === "h5") {
                this.contentData[this.content_index_select].config.image =
                  info.file.response.data.url;
              } else {
                this.contentData[
                  this.content_index_select
                ].config.thumb_media_id_url = info.file.response.data.url;

                this.contentData[
                  this.content_index_select
                ].config.thumb_media_id = info.file.response.data.path;
              }
              // this.contentData[this.content_index_select].config.image =
              //   info.file.response.data.url;
              // this.contentData[this.content_index_select].config.url = info.file.response.data.path
            }
          } else {
            that.$message.error(`错误：${info.file.response.msg}`);
          }
        } else {
          this.$message.error(`错误：图片上传失败`);
        }
      }
      if (info.file.status === "error") {
        // 上传失败
        this.loading = false;
        this.$message.error(`错误：图片上传失败`);
      }
    },

    // 删除子菜单
    delContentB() {
      let z_data = this.contentData[this.content_index_select];
      console.log("z_data", z_data);
      if (z_data.sub_button.length > 1) {
        z_data.sub_button.splice(z_data.second_index, 1);
        z_data.second_index = z_data.sub_button.length - 1;
      } else {
        // 这里要重置一级菜单的状态。当子菜单全部删除后，在进行删除一级菜单，然后会显示另一个一级菜单，但是此时这个菜单的show_type值为3，但是实际应该为2或者1，所以就会出现报错
        this.contentData.forEach((res) => {
          res.second_index = -1; // 子菜单的状态重置了，下面的一级菜单的状态也要重置，不然会报错
          if (res.sub_button.length > 0) {
            // 这里要重置所有一级菜单的状态，免得删除一级菜单的时候会报错
            res.show_type = 1;
          } else {
            res.show_type = 2;
          }
        });
        z_data.show_type = 2;
        z_data.sub_button.splice(0, 1);
      }
      // this.contentData[this.content_index_select] = z_data
    },
    // 保存并发布
    async getMuneData() {
      let that = this;
      if (this.contentData.length == 0) {
        return [];
      }
      // return this.contentData;
      let r_arr = [];
      const for_gzh = () => {
        return new Promise((resolve) => {
          let r_number = 0;
          for (let i = 0; i < that.contentData.length; i++) {
            let r_data = {
              name: that.contentData[i].name || "",
              type: that.contentData[i].type, // view-网页类型，click-点击类型， miniprogram - 小程序类型
              sub_button: [],
              config: {
                type: 1,
                content: "",
                media_id: "",
                media_id_url: "",
                title: "",
                description: "",
                url: "",
                image: "",
                appid: "",
                pagepath: "",
                thumb_media_id: "",
                thumb_media_id_url: "",
              },
            };
            if (
              that.contentData[i].type == "click" &&
              that.contentData[i].sub_button.length == 0
            ) {
              // 一级菜单--发送消息
              r_data.key = 0; // 这个字段非click就不传。固定传0
              r_data.config.type = that.contentData[i].config.type;
              if (that.contentData[i].config.type == 1) {
                r_data.config.content = encodeURIComponent(
                  that.contentData[i].config.content || ""
                );
                r_number = r_number + 1;
              } else if (that.contentData[i].config.type == 2) {
                r_data.config.media_id =
                  that.contentData[i].config.media_id || "";
                r_data.config.media_id_url =
                  that.contentData[i].config.media_id_url || "";
                r_number = r_number + 1;
              } else if (that.contentData[i].config.type == 3) {
                r_data.config.title = that.contentData[i].config.title || "";
                r_data.config.description =
                  that.contentData[i].config.description || "";
                r_data.config.url = that.contentData[i].config.url || "";
                r_data.config.image = that.contentData[i].config.image || "";
                r_number = r_number + 1;
              } else if (that.contentData[i].config.type == 5) {
                if (this.set_type === "mini") {
                  r_data.config.title = that.contentData[i].config.title || "";
                  r_data.config.appid = that.contentData[i].config.appid || "";
                  r_data.config.pagepath =
                    that.contentData[i].config.pagepath || "";
                  r_data.config.thumb_media_id_url =
                    that.contentData[i].config.thumb_media_id_url || "";
                  r_data.config.thumb_media_id =
                    that.contentData[i].config.thumb_media_id || "";
                  r_number = r_number + 1;
                }
              }
              r_arr.push(r_data);
              if (r_number == that.contentData.length) {
                // 保证循环完毕
                resolve("校验成功");
              }
            } else if (
              that.contentData[i].type == "view" &&
              that.contentData[i].sub_button.length == 0
            ) {
              r_number = r_number + 1;
              r_data.url = that.contentData[i].url || "";
              r_arr.push(r_data);
              if (r_number == that.contentData.length) {
                resolve("校验成功");
              }
            } else if (
              that.contentData[i].type == "miniprogram" &&
              that.contentData[i].sub_button.length == 0
            ) {
              r_number = r_number + 1;
              r_data.appid = that.contentData[i].appid || "";
              r_data.pagepath = that.contentData[i].pagepath || "";
              r_data.url = that.contentData[i].url || "";

              r_arr.push(r_data);
              if (r_number == that.contentData.length) {
                // 保证循环完毕
                // delete r_data.config
                resolve("校验成功");
              }
            } else if (that.contentData[i].sub_button.length > 0) {
              // 有子菜单，判断子菜单的内容
              const dddPromise = new Promise((resolve_z) => {
                let zz_number = 0;
                let dddContent = that.contentData[i].sub_button;
                for (let z = 0; z < dddContent.length; z++) {
                  let ddd_data = {
                    name: dddContent[z].name || "",
                    type: dddContent[z].type, // view-网页类型，click-点击类型，miniprogram-小程序类型
                    config: {
                      type: 1,
                      content: "",
                      media_id: "",
                      media_id_url: "",
                      title: "",
                      description: "",
                      url: "",
                      image: "",
                      appid: "",
                      pagepath: "",
                      thumb_media_id: "",
                      thumb_media_id_url: "",
                    },
                  };
                  if (dddContent[z].type == "click") {
                    ddd_data.key = 0; // 这个字段非click就不传。固定传0
                    ddd_data.config.type = dddContent[z].config.type;
                    if (dddContent[z].config.type == 1) {
                      ddd_data.config.content = encodeURIComponent(
                        dddContent[z].config.content || ""
                      );
                      zz_number = zz_number + 1;
                    } else if (dddContent[z].config.type == 2) {
                      ddd_data.config.media_id =
                        dddContent[z].config.media_id || "";
                      ddd_data.config.media_id_url =
                        dddContent[z].config.media_id_url || "";

                      zz_number = zz_number + 1;
                    } else if (dddContent[z].config.type == 3) {
                      ddd_data.config.title = dddContent[z].config.title || "";
                      ddd_data.config.description =
                        dddContent[z].config.description || "";
                      ddd_data.config.url = dddContent[z].config.url || "";
                      ddd_data.config.image = dddContent[z].config.image || "";

                      zz_number = zz_number + 1;
                    }
                    if (dddContent[z].config.type == 5) {
                      ddd_data.config.title = dddContent[z].config.title || "";
                      ddd_data.config.pagepath =
                        dddContent[z].config.pagepath || "";
                      ddd_data.config.appid = dddContent[z].config.appid || "";

                      ddd_data.config.thumb_media_id_url =
                        dddContent[z].config.thumb_media_id_url || "";

                      ddd_data.config.thumb_media_id =
                        dddContent[z].config.thumb_media_id || "";
                      zz_number = zz_number + 1;
                    }

                    r_data.sub_button.push(ddd_data);
                    if (zz_number == dddContent.length) {
                      // 保证循环完毕
                      resolve_z("校验成功");
                    }
                  } else if (dddContent[z].type == "view") {
                    zz_number = zz_number + 1;
                    ddd_data.url = dddContent[z].url || "";
                    r_data.sub_button.push(ddd_data);
                    if (zz_number == dddContent.length) {
                      // 保证循环完毕
                      resolve_z("校验成功");
                    }
                  } else if (dddContent[z].type == "miniprogram") {
                    zz_number = zz_number + 1;
                    ddd_data.appid = dddContent[z].appid || "";
                    ddd_data.pagepath = dddContent[z].pagepath || "";
                    ddd_data.url = dddContent[z].url || "";
                    r_data.sub_button.push(ddd_data);
                    if (zz_number == dddContent.length) {
                      // 保证循环完毕
                      resolve_z("校验成功");
                    }
                  }
                }
              });

              dddPromise.then(() => {
                r_number = r_number + 1;
                r_arr.push(r_data);
                if (r_number == that.contentData.length) {
                  // 保证循环完毕
                  resolve("校验成功");
                }
              });
            }
          }
        });
      };
      let result = [];
      await for_gzh();
      that.contentData.forEach((res) => {
        r_arr.forEach((re_z) => {
          if (res.name == re_z.name) {
            result.push(re_z);
          }
        });
      });
      return result;
    },

    // 保存并发布
    sendButton() {
      let that = this;
      const typeText = this.set_type === "h5" ? `h5站` : `小程序`;
      if (this.contentData.length == 0) {
        that.$message.warning(`${typeText}内容不能为空`);
        return;
      }
      let r_arr = [];
      const for_gzh = new Promise((resolve, reject) => {
        let r_number = 0;
        for (let i = 0; i < that.contentData.length; i++) {
          let r_data = {
            name: that.contentData[i].name,
            type: that.contentData[i].type, // view-网页类型，click-点击类型，miniprogram-小程序类型
            sub_button: [],
            config: {
              type: 1,
              content: "",
              media_id: "",
              media_id_url: "",
              title: "",
              description: "",
              url: "",
              image: "",
              appid: "",
              pagepath: "",
              thumb_media_id: "",
              thumb_media_id_url: "",
            },
          };
          if (!that.contentData[i].name) {
            that.$message.warning(`${typeText}请填写菜单名称`);
            break;
          } else if (
            that.contentData[i].type == "click" &&
            that.contentData[i].sub_button.length == 0
          ) {
            // 一级菜单--发送消息
            r_data.key = 0; // 这个字段非click就不传。固定传0

            r_data.config.type = that.contentData[i].config.type;
            // console.log(that.contentData[i]);
            if (that.contentData[i].config.type == 1) {
              // 文本消息
              if (!that.contentData[i].config.content) {
                that.$message.warning(
                  `${typeText}菜单:${that.contentData[i].name}---请填写文本消息内容`
                );
                return;
              }
              r_data.config.content = encodeURIComponent(
                that.contentData[i].config.content
              );

              r_number = r_number + 1;
            } else if (that.contentData[i].config.type == 2) {
              // 图片消息
              if (
                (!that.contentData[i].config.media_id ||
                  !that.contentData[i].config.media_id_url) &&
                that.page_type != "config-template"
              ) {
                that.$message.warning(
                  `${typeText}菜单:${that.contentData[i].name}---缺少图片信息`
                );
                return;
              } else if (
                !that.contentData[i].config.media_id_url &&
                that.page_type == "config-template"
              ) {
                that.$message.warning(
                  `${typeText}菜单:${that.contentData[i].name}---缺少图片信息`
                );
                return;
              }
              r_data.config.media_id = that.contentData[i].config.media_id;
              r_data.config.media_id_url =
                that.contentData[i].config.media_id_url;

              r_number = r_number + 1;
            } else if (that.contentData[i].config.type == 3) {
              // 图文消息
              if (!that.contentData[i].config.title) {
                that.$message.warning(
                  `${typeText}菜单:${that.contentData[i].name}---请填写消息标题`
                );
                return;
              } else if (!that.contentData[i].config.description) {
                that.$message.warning(
                  `${typeText}菜单:${that.contentData[i].name}---请填写消息描述`
                );
                return;
              } else if (!that.contentData[i].config.url) {
                that.$message.warning(
                  `${typeText}菜单:${that.contentData[i].name}---请填写消息链接`
                );
                return;
              } else if (!that.contentData[i].config.image) {
                that.$message.warning(
                  `${typeText}菜单:${that.contentData[i].name}---请上传消息图片`
                );
                return;
              }

              r_data.config.title = that.contentData[i].config.title;
              r_data.config.description =
                that.contentData[i].config.description;
              r_data.config.url = that.contentData[i].config.url;
              r_data.config.image = that.contentData[i].config.image;

              r_number = r_number + 1;
            }
            // 小程序卡片
            else if (that.contentData[i].config.type == 5) {
              if (this.set_type === "mini") {
                // 一级菜单 小程序卡片
                if (!that.contentData[i].config.title) {
                  that.$message.warning(
                    `${typeText}菜单:${that.contentData[i].name}---请填写小程序标题`
                  );
                  return;
                } else if (!that.contentData[i].config.appid) {
                  that.$message.warning(
                    `${typeText}菜单:${that.contentData[i].name}---请填写小程序appid`
                  );
                  return;
                } else if (!that.contentData[i].config.thumb_media_id_url) {
                  that.$message.warning(
                    `${typeText}菜单:${that.contentData[i].name}---请上传消息封面图`
                  );
                  return;
                } else if (!that.contentData[i].config.pagepath) {
                  that.$message.warning(
                    `${typeText}菜单:${that.contentData[i].name}---请填写小程序路径`
                  );
                  return;
                }
                // console.log(`小程序菜单 `)
                // console.log(that.contentData[i].config)
                r_data.config.title = that.contentData[i].config.title;
                r_data.config.appid = that.contentData[i].config.appid;
                r_data.config.pagepath = that.contentData[i].config.pagepath;
                r_data.config.thumb_media_id_url =
                  that.contentData[i].config.thumb_media_id_url;
                console.log(`6666666`);
                console.log(that.contentData[i].config);
                r_data.config.thumb_media_id =
                  that.contentData[i].config.thumb_media_id || "";
                r_number = r_number + 1;
              }
            }

            r_arr.push(r_data);
            if (r_number == that.contentData.length) {
              // 保证循环完毕
              resolve("校验成功");
            }
          } else if (
            that.contentData[i].type == "view" &&
            that.contentData[i].sub_button.length == 0
          ) {
            // 网页类型
            if (!that.contentData[i].url) {
              that.$message.warning(
                `${typeText}菜单:${that.contentData[i].name}---请填写跳转的网页链接`
              );
              return;
            }
            r_number = r_number + 1;
            r_data.url = that.contentData[i].url;

            r_arr.push(r_data);
            if (r_number == that.contentData.length) {
              // 保证循环完毕
              // delete r_data.config
              resolve("校验成功");
            }
          } else if (
            that.contentData[i].type == "miniprogram" &&
            that.contentData[i].sub_button.length == 0
          ) {
            // 小程序类型
            if (!that.contentData[i].appid) {
              that.$message.warning(
                `${typeText}菜单:${that.contentData[i].name}---请填写APPID`
              );
              return;
            } else if (!that.contentData[i].pagepath) {
              that.$message.warning(
                `${typeText}菜单:${that.contentData[i].name}---请填写小程序的页面路径`
              );
              return;
            } else if (!that.contentData[i].url) {
              that.$message.warning(
                `${typeText}菜单:${that.contentData[i].name}---请填写备用页面链接`
              );
              return;
            }
            r_number = r_number + 1;

            r_data.appid = that.contentData[i].appid;
            r_data.pagepath = that.contentData[i].pagepath;
            r_data.url = that.contentData[i].url;

            r_arr.push(r_data);
            if (r_number == that.contentData.length) {
              // 保证循环完毕
              // delete r_data.config
              resolve("校验成功");
            }
          } else if (that.contentData[i].sub_button.length > 0) {
            // 有子菜单，判断子菜单的内容
            const dddPromise = new Promise((resolve_z, reject_z) => {
              let zz_number = 0;
              let dddContent = that.contentData[i].sub_button;

              for (let z = 0; z < dddContent.length; z++) {
                let ddd_data = {
                  name: dddContent[z].name,
                  type: dddContent[z].type, // view-网页类型，click-点击类型，miniprogram-小程序类型
                  // url: "",
                  // appid: "",
                  // pagepath: "",
                  // sub_button: [],
                  config: {
                    type: 1,
                    content: "",
                    media_id: "",
                    media_id_url: "",
                    title: "",
                    description: "",
                    url: "",
                    image: "",
                    appid: "",
                    pagepath: "",
                    thumb_media_id: "",
                    thumb_media_id_url: "",
                  },
                };

                if (!dddContent[z].name) {
                  that.$message.warning(`${typeText}请填写子菜单名称`);
                  break;
                } else if (dddContent[z].type == "click") {
                  ddd_data.key = 0; // 这个字段非click就不传。固定传0
                  ddd_data.config.type = dddContent[z].config.type;

                  if (dddContent[z].config.type == 1) {
                    // 文本消息
                    if (!dddContent[z].config.content) {
                      that.$message.warning(
                        `${typeText}子菜单:${dddContent[z].name}---请填写文本消息内容`
                      );
                      return;
                    }
                    // console.log("encodeURIComponent",dddContent[z].config.content);
                    ddd_data.config.content = encodeURIComponent(
                      dddContent[z].config.content
                    );

                    zz_number = zz_number + 1;
                  } else if (dddContent[z].config.type == 2) {
                    // 图片消息
                    if (
                      (!dddContent[z].config.media_id ||
                        !dddContent[z].config.media_id_url) &&
                      that.page_type != "config-template"
                    ) {
                      that.$message.warning(
                        `${typeText}菜单:${that.contentData[i].name}---缺少图片信息`
                      );
                      return;
                    } else if (
                      !dddContent[z].config.media_id_url &&
                      that.page_type == "config-template"
                    ) {
                      that.$message.warning(
                        `${typeText}菜单:${that.contentData[i].name}---缺少图片信息`
                      );
                      return;
                    }

                    ddd_data.config.media_id = dddContent[z].config.media_id;
                    ddd_data.config.media_id_url =
                      dddContent[z].config.media_id_url;

                    zz_number = zz_number + 1;
                  } else if (dddContent[z].config.type == 3) {
                    // 图文消息
                    if (!dddContent[z].config.title) {
                      that.$message.warning(
                        `${typeText}子菜单:${dddContent[z].name}---请填写消息标题`
                      );
                      return;
                    } else if (!dddContent[z].config.description) {
                      that.$message.warning(
                        `${typeText}子菜单:${dddContent[z].name}---请填写消息描述`
                      );
                      return;
                    } else if (!dddContent[z].config.url) {
                      that.$message.warning(
                        `${typeText}子菜单:${dddContent[z].name}---请填写消息链接`
                      );
                      return;
                    } else if (!dddContent[z].config.image) {
                      that.$message.warning(
                        `${typeText}子菜单:${dddContent[z].name}---请上传消息图片`
                      );
                      return;
                    }
                    ddd_data.config.title = dddContent[z].config.title;
                    ddd_data.config.description =
                      dddContent[z].config.description;
                    ddd_data.config.url = dddContent[z].config.url;
                    ddd_data.config.image = dddContent[z].config.image;

                    zz_number = zz_number + 1;
                  }
                  //
                  if (dddContent[z].config.type == 5) {
                    if (
                      !dddContent[z].config.title &&
                      that.page_type == "config-template"
                    ) {
                      that.$message.warning(
                        `${typeText}菜单:${that.contentData[i].name}---请填写小程序标题`
                      );
                      return;
                    }
                    if (
                      !dddContent[z].config.pagepath &&
                      that.page_type == "config-template"
                    ) {
                      that.$message.warning(
                        `${typeText}菜单:${that.contentData[i].name}---请填写小程序路径`
                      );
                      return;
                    }
                    if (
                      !dddContent[z].config.appid &&
                      that.page_type == "config-template"
                    ) {
                      that.$message.warning(
                        `${typeText}菜单:${that.contentData[i].name}---请填写小程序APPID`
                      );
                      return;
                    }
                    if (
                      !dddContent[z].config.thumb_media_id_url &&
                      that.page_type == "config-template"
                    ) {
                      that.$message.warning(
                        `${typeText}菜单:${that.contentData[i].name}---请上传消息封面图`
                      );
                      return;
                    }
                    ddd_data.config.title = dddContent[z].config.title;
                    ddd_data.config.pagepath = dddContent[z].config.pagepath;
                    ddd_data.config.appid = dddContent[z].config.appid;
                    ddd_data.config.thumb_media_id_url =
                      dddContent[z].config.thumb_media_id_url;
                    console.log(`777`, dddContent[z].config);
                    ddd_data.config.thumb_media_id =
                      dddContent[z].config.thumb_media_id;

                    zz_number = zz_number + 1;
                  }

                  r_data.sub_button.push(ddd_data);
                  if (zz_number == dddContent.length) {
                    // 保证循环完毕
                    resolve_z("校验成功");
                  }
                } else if (dddContent[z].type == "view") {
                  if (!dddContent[z].url) {
                    that.$message.warning(
                      `${typeText}子菜单:${dddContent[z].name}---请填写跳转的网页链接`
                    );
                    return;
                  }
                  zz_number = zz_number + 1;
                  ddd_data.url = dddContent[z].url;

                  r_data.sub_button.push(ddd_data);
                  if (zz_number == dddContent.length) {
                    // 保证循环完毕
                    resolve_z("校验成功");
                  }
                } else if (dddContent[z].type == "miniprogram") {
                  if (!dddContent[z].appid) {
                    that.$message.warning(
                      `${typeText}子菜单:${dddContent[z].name}---请填写APPID`
                    );
                    return;
                  } else if (!dddContent[z].pagepath) {
                    that.$message.warning(
                      `${typeText}子菜单:${dddContent[z].name}---请填写小程序的页面路径`
                    );
                    return;
                  } else if (!dddContent[z].url) {
                    that.$message.warning(
                      `${typeText}子菜单:${dddContent[z].name}---请填写备用页面链接`
                    );
                    return;
                  }
                  zz_number = zz_number + 1;

                  ddd_data.appid = dddContent[z].appid;
                  ddd_data.pagepath = dddContent[z].pagepath;
                  ddd_data.url = dddContent[z].url;

                  r_data.sub_button.push(ddd_data);
                  if (zz_number == dddContent.length) {
                    // 保证循环完毕
                    resolve_z("校验成功");
                  }
                }
              }
            });

            dddPromise.then((res) => {
              r_number = r_number + 1;
              r_arr.push(r_data);
              if (r_number == that.contentData.length) {
                // 保证循环完毕
                resolve("校验成功");
              }
            });
          }
        }
      });

      for_gzh.then((res) => {
        if (that.page_type != "config-template") {
          that.search_button_loading = true;
        }
        // alert("校验通过，开始请求")
        // 给请求的内容重新排下序。也许是因为for循环里面又套了for循环，并且里面还有Promise的原因，导致当有子菜单的数据，总会排在最后面
        let a_data = [];
        that.contentData.forEach((res) => {
          r_arr.forEach((re_z) => {
            if (res.name == re_z.name) {
              a_data.push(re_z);
            }
          });
        });
        if (that.page_type == "config-template") {
          that.$emit("menu-handle", a_data);
          return;
        }

        gzhMenuAdd({
          gzh_id: that.r_gzh_id,
          menu: {
            button: a_data,
          },
          content_type: that.set_type === "h5" ? 1 : 2,
        }).then((res) => {
          // console.log("保存并发布",res);
          that.search_button_loading = false;
          if (
            res.data.code == 0 ||
            res.data.code == 200 ||
            res.data.code == 8011
          ) {
            that.$message.success(`公众号：${that.gzh_name}， 保存并发布成功`);
          } else {
            that.$message.error(`错误：${res.data.msg}`);
          }
        });
      });
    },

    // 裁切图片
    cutCover(e) {
      let that = this;
      that.cut_type = e;
      if (e == 1) {
        // 一级菜单
        let data_img =
          that.contentData[that.content_index_select].config.image.split("?");
        this.$refs.getCropperImg.cutImgHandle(data_img[0], [10, 10]);
      } else if (e == 2) {
        // 子菜单
        let data_img =
          that.contentData[that.content_index_select].sub_button[
            that.contentData[that.content_index_select].second_index
          ].config.image.split("?");
        this.$refs.getCropperImg.cutImgHandle(data_img[0], [10, 10]);
      }
    },
    // 裁切弹窗确认
    cropperOk(img) {
      let that = this;
      if (that.cut_type == 1) {
        // 一级菜单
        that.contentData[that.content_index_select].config.image = img;
      } else if (that.cut_type == 2) {
        // 子菜单
        that.contentData[that.content_index_select].sub_button[
          that.contentData[that.content_index_select].second_index
        ].config.image = img;
      }
      this.$refs.getCropperImg.cutHandleCancel();
    },

    // 同步到其他公众号
    syncHandleOk() {
      let that = this;
      let i_data = []; // 把选中的公众号id放入里面
      let tab_data = [];
      that.syncGzhData.forEach((res) => {
        res.value.forEach((res_z) => {
          if (res_z.checked_z) {
            i_data.push(res_z.id);

            let t_obj = {
              gzh_name: res_z.gzh_name,
              id: res_z.id,
              content: [],
            };
            tab_data.push(t_obj);
          }
        });
      });

      // if(i_data.length == 0){
      // 	that.$message.warning('请选择公众号');
      // 	return
      // }
      let g_data = [];
      if (that.gzhTab_control == 1) {
        let obj = {
          gzh_id: that.r_gzh_id,
          gzh_name: that.gzh_name,
          content: that.contentData,
        };
        that.originalTabObj = obj;
        that.gzhTab_control = that.gzhTab_control + 1;
      }
      g_data.push(that.originalTabObj);
      if (tab_data.length > 0) {
        tab_data.forEach((res) => {
          let g_obj = {
            gzh_id: res.id,
            gzh_name: res.gzh_name,
            content: JSON.parse(JSON.stringify(that.originalTabObj.content)),
          };
          g_data.push(g_obj);
        });
      } else {
        that.contentData = that.originalTabObj.content;
      }

      that.gzhTabData = g_data;

      // console.log("tab_data",tab_data);
      // console.log("that.gzhTabData", that.gzhTabData);

      that.$emit("select-sync-gzh", tab_data);
      that.syncHandleCancel();
    },
    syncHandleCancel() {
      this.sync_confirmLoading = false;
      this.sync_visible = false;
    },
    // 全选/取消全选
    onCheckAllChange(e, item, index) {
      let that = this;
      if (that.syncGzhData[index].checked_all) {
        that.syncGzhData[index].value.forEach((res) => {
          res.checked_z = false;
        });
        that.syncGzhData[index].checked_all = false;
      } else {
        that.syncGzhData[index].value.forEach((res) => {
          res.checked_z = true;
        });
        that.syncGzhData[index].checked_all = true;
      }
    },
    // 单选
    onCheckChange(e, item_z, index, index_z) {
      let that = this;
      // console.log(that.syncGzhData[index])
      item_z.checked_z = !item_z.checked_z;
      // that.gzhData[index].value[index_z].checked_z = !that.gzhData[index].value[index_z].checked_z
      let ttt = true; // 用于判断是否全选
      that.syncGzhData[index].value.forEach((res) => {
        if (!res.checked_z) {
          ttt = false;
        }
      });
      if (ttt) {
        that.syncGzhData[index].checked_all = true; // 全选
      } else {
        that.syncGzhData[index].checked_all = false; // 取消全选
      }
    },

    // 上传图片
    imgUploadHandle(e) {
      console.log("上传图片", e);
    },

    campaignNameBlur(e, type) {
      // console.log("111",e.srcElement.selectionStart);
      this.campaignNameIndex = e.srcElement.selectionStart; // 获取光标所在位置
      this.campaign_type = type;
    },
    campaignFormatChar(text_value) {
      let index = this.campaignNameIndex;
      if (this.contentData[this.content_index_select].show_type == 2) {
        // 一级菜单
        let textData = this.contentData[this.content_index_select].config;
        let t_cont = this.contentData[this.content_index_select];
        if (this.campaign_type == 1) {
          // 菜单名称
          t_cont.name =
            t_cont.name.slice(0, index) + text_value + t_cont.name.slice(index);
          this.$refs.focusA.focus();
        } else if (this.campaign_type == 2) {
          // 文本消息内容
          textData.content =
            textData.content.slice(0, index) +
            text_value +
            textData.content.slice(index);
          this.$refs.focusB.focus();
        } else if (this.campaign_type == 3) {
          // 一级菜单-单图文-消息标题
          textData.title =
            textData.title.slice(0, index) +
            text_value +
            textData.title.slice(index);
          this.$refs.focusC.focus();
        } else if (this.campaign_type == 4) {
          // 一级菜单-单图文-消息描述
          textData.description =
            textData.description.slice(0, index) +
            text_value +
            textData.description.slice(index);
          this.$refs.focusD.focus();
        } else if (this.campaign_type == 5) {
          // 一级菜单-单图文-消息链接URL
          textData.url =
            textData.url.slice(0, index) +
            text_value +
            textData.url.slice(index);
          this.$refs.focusE.focus();
        } else if (this.campaign_type == 6) {
          // 一级菜单-网页链接
          this.contentData[this.content_index_select].url =
            t_cont.url.slice(0, index) + text_value + t_cont.url.slice(index);
          this.$refs.focusF.focus();
        } else if (this.campaign_type == 13) {
          // 一级菜单-跳转小程序-APPID
          this.contentData[this.content_index_select].appid =
            t_cont.appid.slice(0, index) +
            text_value +
            t_cont.appid.slice(index);
          this.$refs.focusM.focus();
        } else if (this.campaign_type == 14) {
          // 一级菜单-跳转小程序-页面路径
          this.contentData[this.content_index_select].pagepath =
            t_cont.pagepath.slice(0, index) +
            text_value +
            t_cont.pagepath.slice(index);
          this.$refs.focusN.focus();
        } else if (this.campaign_type == 15) {
          // 一级菜单-跳转小程序-备用页面
          this.contentData[this.content_index_select].url =
            t_cont.url.slice(0, index) + text_value + t_cont.url.slice(index);
          this.$refs.focusO.focus();
        }
      } else if (this.contentData[this.content_index_select].show_type == 1) {
        // 一级菜单-有子菜单时
        let t_cont = this.contentData[this.content_index_select];
        if (this.campaign_type == 1) {
          // 菜单名称
          t_cont.name =
            t_cont.name.slice(0, index) + text_value + t_cont.name.slice(index);
          this.$refs.focusA.focus();
        }
      } else if (this.contentData[this.content_index_select].show_type == 3) {
        // 子菜单
        let textData =
          this.contentData[this.content_index_select].sub_button[
            this.contentData[this.content_index_select].second_index
          ].config;
        let t_Data =
          this.contentData[this.content_index_select].sub_button[
            this.contentData[this.content_index_select].second_index
          ];
        if (this.campaign_type == 7) {
          // 子级菜单-名称
          t_Data.name =
            t_Data.name.slice(0, index) + text_value + t_Data.name.slice(index);
          this.$refs.focusG.focus();
        } else if (this.campaign_type == 8) {
          // 子级菜单-文本消息内容
          textData.content =
            textData.content.slice(0, index) +
            text_value +
            textData.content.slice(index);
          this.$refs.focusH.focus();
        } else if (this.campaign_type == 9) {
          // 子级菜单-单图文-消息标题
          textData.title =
            textData.title.slice(0, index) +
            text_value +
            textData.title.slice(index);
          this.$refs.focusI.focus();
        } else if (this.campaign_type == 10) {
          // 子级菜单-单图文-消息描述
          textData.description =
            textData.description.slice(0, index) +
            text_value +
            textData.description.slice(index);
          this.$refs.focusJ.focus();
        } else if (this.campaign_type == 11) {
          // 子级菜单-单图文-消息链接URL
          textData.url =
            textData.url.slice(0, index) +
            text_value +
            textData.url.slice(index);
          this.$refs.focusK.focus();
        } else if (this.campaign_type == 12) {
          // 子级菜单-网页链接
          t_Data.url =
            t_Data.url.slice(0, index) + text_value + t_Data.url.slice(index);
          this.$refs.focusL.focus();
        } else if (this.campaign_type == 16) {
          // 子级菜单-跳转小程序-APPID
          t_Data.appid =
            t_Data.appid.slice(0, index) +
            text_value +
            t_Data.appid.slice(index);
          this.$refs.focusP.focus();
        } else if (this.campaign_type == 17) {
          // 子级菜单-跳转小程序-页面路径
          t_Data.pagepath =
            t_Data.pagepath.slice(0, index) +
            text_value +
            t_Data.pagepath.slice(index);
          this.$refs.focusQ.focus();
        } else if (this.campaign_type == 18) {
          // 子级菜单-跳转小程序-备用页面
          t_Data.url =
            t_Data.url.slice(0, index) + text_value + t_Data.url.slice(index);
          this.$refs.focusR.focus();
        }
        // 小程序APPID
        else if (this.campaign_type == 50) {
          // 子级菜单-跳转小程序-备用页面
          textData.appid =
            textData.appid.slice(0, index) +
            text_value +
            textData.appid.slice(index);
          this.$refs.focusLL.focus();
        }
        // 小程序路径
        else if (this.campaign_type == 51) {
          // 子级菜单-跳转小程序-备用页面
          textData.pagepath =
            textData.pagepath.slice(0, index) +
            text_value +
            textData.pagepath.slice(index);
          this.$refs.focusZZ.focus();
        }
      }

      // else {

      // }
    },
  },
};
</script>

<style scoped>
.class-title {
  width: 70px;
}

.gzh-window-box {
  width: 300px;
  height: 600px;
  flex-shrink: 0;
  /* background-color: #ededed; */
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border: 1px solid #e9e9e9;
}

.add-button {
  height: 46px;
  border: 1px solid #cbcbcb;
  background-color: #fff;
  cursor: pointer;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  word-break: break-all;
}
.gzh-nav-box {
  position: absolute;
  bottom: 55px;
  left: 50%;
  transform: translateX(-50%);
}
.gzh-nav {
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #cbcbcb;
  padding: 5px 0;
  min-height: 40px;
  width: 90px;
  cursor: pointer;
  /* overflow: hidden; */
  /* white-space: nowrap; */
  font-size: 12px;
}
.triangle-icon {
  position: relative;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 5px solid #cbcbcb;
}

/* 图片裁切 */
.cover-handle {
  display: none;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 9;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  /* display: flex; */
  align-items: center;
  justify-content: space-around;
}
.cover-box:hover .cover-handle {
  display: flex;
}

.type-3:hover .cover-handle {
  display: flex;
}

.temp-event-all {
  pointer-events: all;
}
</style>
